import Icon from './Icon';

const ShareFb = ({ className }) => (
  <Icon name="share-fb" className={className} viewBox="0 0 31 31">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1262.000000, -161.000000)">
        <g transform="translate(1145.000000, 158.000000)">
          <g transform="translate(117.000000, 3.000000)">
            <g>
              <ellipse
                fill="#3A579A"
                cx="15.5"
                cy="15.7035601"
                rx="15.5"
                ry="15.2964399"
              />
              <path
                d="M19.4285455,11.2620302 L19.4285455,8.75063291 L17.112,8.75063291 C15.1871818,8.75063291 13.7517879,10.3609309 13.7517879,12.3568845 L13.7517879,13.7409805 L11.2727273,13.7409805 L11.2727273,16.1235169 L13.7517879,16.1235169 L13.7517879,23.2386791 L16.5248788,23.2386791 L16.5248788,16.1235169 L19.4285455,16.1235169 L19.4285455,13.7409805 L16.5248788,13.7409805 L16.5248788,12.0991627 C16.5248788,11.616166 16.8189091,11.2620302 17.112,11.2620302 L19.4285455,11.2620302 Z"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);

export default ShareFb;
